import React, { useEffect } from "react";

import { AccordionDetails, Chip, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import { useLocation } from "react-router-dom";

import { getSearchedGamesStart } from "../../../../../../redux-saga/redux/casino/lobby/casinoGames";
import { formatCategoryName } from "../../../../../../utils/helper";
import useStyles from "./Sections.styles";

const CategorySection = ({
  offset,
  searchInput,
  selectedCategory,
  selectedProvider,
  removeSelectedItem,
  setCategory
}) => {
  const classes = useStyles();
  const { subCategory } = useSelector((state) => state.casinoLobby);
  const dispatch = useDispatch();
  const location = useLocation();
  // || location.pathname === "/casino/slotGame"
  useEffect(() => {
    if (location.pathname === "/casino/casinoLive") {
      setCategory(380, "Live casino");
      let filters = {
        isMobile,
        page: 1,
        limit: isMobile ? 8 : 12,
        search: searchInput.trim().length ? searchInput : null
      };
      filters.subCategoryId = JSON.stringify([
        ...Object.keys(selectedCategory),
        `${380}`
      ]);
      dispatch(
        getSearchedGamesStart({
          ...filters
        })
      );
    }
    if (location.pathname === "/casino/slotGame") {
      setCategory(375, "Slot games");
      let filters = {
        isMobile,
        page: 1,
        limit: isMobile ? 8 : 12,
        search: searchInput.trim().length ? searchInput : null
      };
      filters.subCategoryId = JSON.stringify([
        ...Object.keys(selectedCategory),
        `${375}`
      ]);
      dispatch(
        getSearchedGamesStart({
          ...filters
        })
      );
    }
  }, [location.pathname]);

  const handleCategory = (id, name) => {
    offset.current = 1;
    if (selectedCategory[id]) {
      removeSelectedItem(`category,${id}`);
      return;
    }
    // console.log("what", id, name);
    setCategory(id, name);
    let filters = {
      isMobile,
      page: 1,
      limit: isMobile ? 8 : 12,
      search: searchInput.trim().length ? searchInput : null
    };
    filters.subCategoryId = JSON.stringify([
      ...Object.keys(selectedCategory),
      `${id}`
    ]);
    let providers = Object.keys(selectedProvider);
    if (providers.length > 0) {
      filters.providerId = JSON.stringify(providers);
    }
    dispatch(
      getSearchedGamesStart({
        ...filters
      })
    );
  };

  return (
    <>
      <AccordionDetails className={classes.accordiondetails}>
        <Grid className={classes.chipcontainer}>
          {subCategory.length > 0
            ? subCategory.map((item) => (
                <Chip
                  color={
                    selectedCategory[item.masterGameSubCategoryId]
                      ? "primary"
                      : "default"
                  }
                  label={formatCategoryName(item.name)}
                  key={`${item.masterGameSubCategoryId}-${item.providerId}`}
                  clickable
                  onClick={() =>
                    handleCategory(
                      item.masterGameSubCategoryId,
                      formatCategoryName(item.name)
                    )
                  }
                />
              ))
            : null}
        </Grid>
      </AccordionDetails>
    </>
  );
};

export default CategorySection;
